














































import { Component, Vue, Emit } from 'vue-property-decorator'

@Component
export default class GvdPublish extends Vue {
  updateDetails: any = {
    summary: '',
    description: '',
    versionStr: '',
    sendNotifications: false
  }

  @Emit('publish')
  confirmPublish () {
    return this.updateDetails
  }

  closeModal () {
    this.$bvModal.hide('gvd-publish-modal')
  }
}
